import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AlertBox from "../../../../components/Messages";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { selectUtilization, selectedCarryingElement } from "../../../../store/slices/aashtoSlice";
import DesignLoadSelection from "./DesignLoadSelection";

function SelectedLoadCarryingElement({ readOnly = false }) {
  const { t } = useTranslation("translation");

  const carryingElement = useSelector(selectedCarryingElement);
  const utilization = useSelector(selectUtilization);

  const [showAlerting, setShowAlerting] = useState(false);

  useEffect(() => {
    setShowAlerting(utilization && utilization > 1);
  }, [utilization]);

  function renderInput() {
    if (readOnly) {
      return <span className="input">{carryingElement.name}</span>;
    } else {
      return <DesignLoadSelection />;
    }
  }

  return (
    <>
      <RowBody
        titleValue={<p>{t("aashto.inner.Selected Load Carrying Element")}</p>}
        inputValue={renderInput()}
      />
      <Col md={8}>
        <AlertBox show={showAlerting} message={t("aashto.inner.largerHollowBarError")} />
      </Col>
    </>
  );
}

export default SelectedLoadCarryingElement;
